

export function checkForAuthError(err) {
  console.log(err);
  if (
    err &&
    err.response &&
    err.response.data &&
    err.response.data.message &&
    typeof err.response.data.message === "string" &&
    err.response.data.message === "Missing Authentication Token"
  ) {
    window.location.href = "/login";
    return;
  }
  throw err;
}

export function responseData(response) {
  let data = response;
  if ("data" in response && response.data) {
    data = response.data;
  }

  if (
    "headers" in response &&
    response.headers &&
    response.headers["x-taabl-metadata-last-key"]
  ) {
    data.lastKey = response.headers["x-taabl-metadata-last-key"];
  }

  return data;
}